import { tokenType } from '../../store/API/types';
import axios, { Method, AxiosInstance } from 'axios';
import noVideoSrc from '../../assets/images/camera-offline.png';
import { onImageLoadSuccess, onImageLoadError, checkSecondToken } from "../../utils";
import {
  BrowseFrameHTMLElement,
  headersType,
  doImageUpdateInterface,
  loginType,
  AsyncAxiosResponseType,
  AsyncResponseType
} from '../types';
import {
  browseMoveInterface,
  browseSequenceInterface,
  browseGoToInterface,
  OcularisServiceDataInterface,
  playBackInterface,
  getStreamNameType,
  getTimeLineInterface,
  initBrowseInterface,
  initBookmarkType,
  doExportAviInterface,
  createBookmarkType,
  ackEventType,
  ptzBoxType,
  triggerPtzType,
  GetLayoutsType,
  GetCameraListType,
  SpaAuthType, SpaDuoAuthType
} from './types';

const {CONFIG} = window;

// TODO
// rewrite token to interceptors instead of passing to request

export class OcularisServiceData implements OcularisServiceDataInterface {
  playback: playBackInterface;

  constructor() {
    this.browseGoto = this.browseGoto.bind(this);
    this.doImageUpdate = this.doImageUpdate.bind(this);

    this.playback = {
      goto: this.browseGoto.bind(this),
      next: this.browseMoveNext.bind(this),
      prev: this.browseMovePrev.bind(this),
      nextSeq: this.browseNextSequence.bind(this),
      prevSeq: this.browsePrevSequence.bind(this)
    }

    this.instance.interceptors.request.use((config) => {
      if (config.url) config.url = checkSecondToken(config.url);
      return config;
    });
  }


  cancelTokens: any = {};
  tokens: string[] = [];
  TOKEN: tokenType = '';
  TOKEN2: tokenType = '';

  baseUrl: string = `https://${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}`;
  instance: AxiosInstance = axios.create({
    baseURL: this.baseUrl,
    timeout: 300000
  });

  getData = async <T>(url: string, method: Method = 'get', headers?: headersType, requestId?: string): AsyncAxiosResponseType<T> => {
    const cancelToken = axios.CancelToken.source();
    if (requestId) this.cancelTokens[requestId] = cancelToken;

    try {
      return this.instance.request<T>({
        url,
        method,
        headers: headers ? headers : null,
        cancelToken: cancelToken.token
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        return err;
      }

      return err;
    }
  };

  getCameraList = async (token: tokenType): AsyncResponseType<GetCameraListType> => {
    const url = `/session/get_camera_list?token=${token}`;
    const {data} = await this.getData<GetCameraListType>(url);
    const {cameras, global_triggers} = data;
    return {cameras, global_triggers};
  };

  getLayouts = async (token: tokenType): AsyncResponseType<GetLayoutsType> => {
    const url = `/session/get_layouts?token=${token}`;
    const {data} = await this.getData<GetLayoutsType>(url);
    return data;
  };

  getStreamName = async ({cameraId, stream_id, token, width, height, pane, requestId}: getStreamNameType) => {
    const uri = `/connect/start_rtmp?flash=true&id=${cameraId}&stream_id=${stream_id}&token=${token}&width=${width}&height=${height}&pane=${pane}`;
    const {data}: any = await this.getData(uri, 'get', {}, requestId);
    this.clearId(requestId);
    return data.stream_id
  };

  getBrowseFrame(token: tokenType = window.state.token, id: string, time: number) {
    const uri = `/session/get_thumbnail?token=${token}&id=${id}&time=${time}`;
    return this.getData(uri, 'get', null, this.generateId());
  };

  getCapibilities(token = window.state.token, pane: number = 0) {
    const url = `/stream/capabilities?token=${token}&pane=${pane}`;
    return this.getData(url, 'get', null);
  };

  getTimeLine = async (params: getTimeLineInterface) => {
    const {token = window.state.token, pane, startTime, endTime, continuationId} = params;
    let url = `/stream/browse/get_timeline?token=${token}&pane=${pane}&start_time=${startTime}&end_time=${endTime}`;
    if (continuationId) url += "&continuation_id=" + continuationId;
    const {data} = await this.getData(url, 'get', null, this.generateId());
    return data;
  };

  // ************* playback video ***************

  fetchImageUrl = async (url: string, id: string) => {
    const elem = document.getElementById(id) as BrowseFrameHTMLElement;

    try {
      const fetchUrl = checkSecondToken(url);
      const data = await fetch(this.baseUrl + fetchUrl);

      if (data.ok) {
        elem.browseFrame = {
          startTime: data.headers.get("x-onssi-time-start") == '0' ? data.headers.get("x-onssi-time-next") : data.headers.get("x-onssi-time-start"),
          endTime: data.headers.get("x-onssi-time-end") == '1' ? data.headers.get("x-onssi-time-next") : data.headers.get("x-onssi-time-end"),
          nextTime: data.headers.get("x-onssi-time-next"),
          receiveTime: data.headers.get("x-onssi-receive-time"),
          responseTime: data.headers.get("x-onssi-response-time"),
          cameraLabel: data.headers.get("x-onssi-camera-label")
        };
        return data.blob();
      } else {
        throw new Error(data.statusText);
      }
    } catch (e) {
      console.log(e);
    }


  };

  doImageUpdate = async (params: doImageUpdateInterface) => {
    const {id, fetchFunc, cb, pane} = params;
    const elem = document.getElementById(id) as BrowseFrameHTMLElement;

    if (elem && !elem.blocked) {
      elem.blocked = true;
      try {
        const blob = await fetchFunc();
        if (blob) {
          if (blob.type !== 'application/json') {
            elem.src = URL.createObjectURL(blob);
          }
          elem.onload = () => {
            onImageLoadSuccess(elem, cb, pane);
          };
          elem.onerror = () => {
            onImageLoadError(elem, cb, noVideoSrc, pane);
          }
        } else {
          throw Error(blob);
        }
      } catch (err) {
        onImageLoadError(elem, cb, noVideoSrc, pane);
      }
    }
  };

  browseMoveNext(params: browseMoveInterface) {
    const {token, id, cb, pane} = params;
    const url = `/stream/browse/next?suppress-inner-headers=true&pane=${pane}&token=${token}`;
    const fetchFunc = () => this.fetchImageUrl(url, id);
    this.doImageUpdate({id, fetchFunc, cb, pane});
  };

  browseMovePrev(params: browseMoveInterface) {
    const {token, id, cb, pane} = params;
    const url = `/stream/browse/prev?suppress-inner-headers=true&pane=${pane}&token=${token}`;
    const fetchFunc = () => this.fetchImageUrl(url, id);
    this.doImageUpdate({id, fetchFunc, cb, pane});
  }

  browseNextSequence(params: browseSequenceInterface) {
    const {time, pane, token, id, cb} = params;
    const url = `/stream/browse/next_seq?suppress-inner-headers=true&time=${time}&pane=${pane}&token=${token}`;
    const fetchFunc = () => this.fetchImageUrl(url, id);
    this.doImageUpdate({id, fetchFunc, cb, pane});
  };

  browsePrevSequence(params: browseSequenceInterface) {
    const {time, pane, token, id, cb} = params;
    const url = `/stream/browse/prev_seq?suppress-inner-headers=true&time=${time}&pane=${pane}&token=${token}`;
    const fetchFunc = () => this.fetchImageUrl(url, id);
    this.doImageUpdate({id, fetchFunc, cb, pane});
  };

  browseGoto(params: browseGoToInterface) {
    const {token, time, pane, dir, id} = params;
    const url = `/stream/browse/goto?suppress-inner-headers=true&time=${time}&dir=${dir === -1 ? 0 : dir}&token=${token}&pane=${pane}`;
    const fetchFunc = () => this.fetchImageUrl(url, id);
    const cb = () => {
    };
    this.doImageUpdate({id, fetchFunc, cb, pane});
  };

  //////////////////////////////////////////////////////////////////

  disconnectPane(token: tokenType, pane: number): void {
    const url = `/stream/disconnect?token=${token}&pane=${pane}`;
    this.getData<any>(url, 'get', null);
  }

  initBrowse({camId, streamId, token, width, height, pane}: initBrowseInterface) {
    const url = `/connect/http_mjpeg?flash=true&id=${camId}&stream_id=${streamId}&token=${token}&width=${width}&height=${height}&pane=${pane}`;
    return this.getData(url, 'get', null, this.generateId())
  }

  startBrowse(token: tokenType, pane: number) {
    const url = `/stream/start_browse?flash=true&pane=${pane}&token=${token}`;
    return this.getData(url, 'get', null, this.generateId())
  };

  initBookmark({url, streamId, token, width, height, pane, requestId}: initBookmarkType) {
    const finalUrl = `/connect/start_bookmark?flash=true&url=${url}&stream_id=${streamId}&token=${token}&width=${width}&height=${height}&pane=${pane}`;
    return this.getData(finalUrl, 'get', null, requestId)
  }

  deviceStatus = async (token: tokenType, id: string, pane: number) => {
    const url = `/session/device_status?token=${token}&id=${id}&pane=${pane}`;
    const {data} = await this.getData(url, 'get', null, this.generateId());
    return data;
  }

  getPrivilledges = async (token: tokenType) => {
    const url = `/session/get_bookmarks_privilledges?token=${token}`;
    const {data} = await this.getData(url);
    return data;
  }

  async login({username, password, cancelId}: loginType): AsyncResponseType<SpaAuthType> {
    const headers = {
      username: username,
      password: password
    };
    if (/[а-яА-ЯЁё]/.test(username) || /[а-яА-ЯЁё]/.test(password)) {
      throw new Error('Please check your username and password and try again');
    }

    const uri = `/spa_auth`;

    const {data} = await this.getData<SpaAuthType>(uri, 'get', headers, cancelId);

    this.TOKEN = data.token;
    return data;
  };

  async duoLogin(token: tokenType, sigResponse: string): AsyncResponseType<SpaDuoAuthType> {
    const url = `/spa_second_auth?token=${token}`;
    const headers = {
      sig_response: sigResponse
    };
    const {data} = await this.getData<SpaDuoAuthType>(url, 'post', headers);

    this.TOKEN2 = data.token2;
    return data;
  }

  checkConnection = async (token: tokenType): AsyncResponseType<any> => {
    const url = `/session/heartbeat?token=${token}`;
    return await this.getData(url);
  };

  doExportAvi = (params: doExportAviInterface) => {
    const {token, start_time, duration, pane, cameraId} = params;
    const url = `/session/export_avi?token=${token}&start_time=${start_time}&duration=${duration}&pane=${pane}&id=${cameraId}`;
    return this.getData(url);
  };

  getAvilist = async (token: tokenType) => {
    return await this.getData(`/session/get_avi_list?token=${token}`);
  };

  doPaneHeartBeat(token: tokenType, pane: number) {
    const url = `/stream/heartbeat?token=${token}&pane=${pane}`;
    return this.getData(url, 'get', null, this.generateId());
  }

  getBookmarks(token: tokenType) {
    const url = `/session/get_bookmarks?token=${token}`;
    return this.getData(url);
  }

  getBkmsInfo(token: tokenType) {
    const url = `/session/get_event_info?token=${token}`;
    return this.getData(url);
  }

  getBkmThumbnailSrc(thumbnailUrl: string, token: tokenType) {
    return `${this.baseUrl}/session/get_bookmark_thumbnail?token=${token}&url=${encodeURI(thumbnailUrl)}`;
  }

  createBookmark(params: createBookmarkType) {
    const {token, start, end, id, data} = params;
    const {tags, classificationId, caseName, cassesId, classificationName, comments} = data;

    let url = `/session/add_bookmark?start=${start}&stop=${end}&occurred=${Date.now()}&id=${id}`;
    if (classificationId) {
      url += `&class_id=${classificationId}`;
      url += `&class_name=${classificationName}`
    }
    if (cassesId) {
      url += `&case_id=${cassesId}`;
      url += `&case_name=${caseName}`
    }

    if (tags) url += `&tag_names=${encodeURIComponent(tags)}`;
    if (comments) url += `&comment=${encodeURIComponent(comments)}`;

    url += `&token=${token}`;

    return this.getData(url)
  }

  getEventsInfo(token: tokenType) {
    const url = `/session/get_event_info?token=${token}`;
    return this.getData(url)
  }

  deleteBookmark(token: tokenType, id: number) {
    const url = `/session/delete_bookmark?id=${id}&token=${token}`;
    return this.getData(url)
  }

  generateId() {
    const genId = () => {
      let id = Math.random() * 1000 + '';
      if (this.cancelTokens[id]) id = genId();
      return id
    };

    return genId();
  };

  addEventTag(token: tokenType, name: string) {
    const url = `/session/add_tag?name=${name}&token=${token}`;
    return this.getData(url)
  }

  ackEvent(params: ackEventType) {
    const {token, eventId, comment, classId, caseId, tagIds, cameraId} = params;
    let url = `/session/ack_event?token=${token}&event_id=${eventId}`;
    if (comment) url += `&comment=${comment}`;
    if (classId) url += `&class_id=${classId}`;
    if (caseId) url += `&case_id=${caseId}`;
    if (tagIds) url += `&tag_ids=${tagIds}`;
    if (cameraId) url += `&camera_id=${cameraId}`;


    return this.getData(url)
  }

  pollEvents(token: tokenType, transactionId: number) {
    const url = `/session/poll_events?transaction_id=${transactionId}&token=${token}`;
    return this.getData(url);
  }

  ptzBox(params: ptzBoxType) {
    const {token, pane} = params;
    const {left, top, right, bottom} = params.coordintates;
    const url = `/stream/ptz/box?token=${token}&pane=${pane}&box=${left},${top},${right},${bottom}`
    return this.getData(url);
  }

  ptzClick(params: ptzBoxType) {
    const {token, pane} = params;
    const {left, top} = params.coordintates;
    const url = `/stream/ptz/click?token=${token}&pane=${pane}&point=${left},${top}`;
    return this.getData(url);
  }

  zoomIn(token: tokenType, pane: number) {
    const url = `/stream/ptz/zoom_in?token=${token}&pane=${pane}`;
    return this.getData(url);
  }

  zoomOut(token: tokenType, pane: number) {
    const url = `/stream/ptz/zoom_out?token=${token}&pane=${pane}`;
    return this.getData(url);
  }

  triggerPTZ(params: triggerPtzType) {
    const {token, triggerId, cameraId, pane} = params;
    const url = `/stream/trigger?token=${token}&trigger_id=${triggerId}&camera_id=${cameraId}&pane=${pane}`;
    return this.getData(url);
  }

  globalTrigger(token: tokenType, triggerId: string) {
    const url = `/session/trigger?token=${token}&trigger_id=${triggerId}`;
    return this.getData(url);
  }

  getPresets(token: tokenType, pane: number) {
    const url = `/stream/get_presets?token=${token}&pane=${pane}`;
    return this.getData(url, 'get', null);
  }

  gotoPreset(token: tokenType, pane: number, presetId: number) {
    const url = `/stream/ptz/goto_preset?token=${token}&pane=${pane}&preset=${presetId}`;
    return this.getData(url);
  }

  cancelAllRequests() {
    Object.keys(this.cancelTokens)
      .map((id: any) => this.cancelRequest(id));
  }

  cancelRequest(id: string) {
    if (!this.cancelTokens[id]) return;
    this.cancelTokens[id].cancel(`Token ${id} cancelled`);
    this.clearId(id);
  }

  clearId(id: string): void {
    if (this.cancelTokens[id]) delete this.cancelTokens[id]
  }

  addCase(token: tokenType, name: string, comment: string) {
    let url = `/session/add_case?token=${token}&name=${name}`;
    if (comment) url += `&comment=${comment}`;

    return this.getData(url)
  }
}

OcularisServiceData.prototype.TOKEN = '';
OcularisServiceData.prototype.TOKEN2 = '';

const ocularisServiceData: OcularisServiceDataInterface = new OcularisServiceData();

window.axios = axios;
window.ocularisServiceData = ocularisServiceData;


export default ocularisServiceData